<div class="visual-map-holder" (focus)="showResoultBlock()">
    <div class="col m12 iframe da-iframe-map" [innerHtml]="visualMap | safe: 'html'">
    </div>
</div>